<template>
    <div class="xunw_ckeditor" component_name="CkEditor" :component_id="id">
        <textarea :id="id"></textarea>
    </div>
</template>
<script>
    /**
     * 组件名称：富文本编辑器
     * 特性：
     *  1、支持v-model双向绑定，可以作为普通表单元素进行操作
     *  2、必须为该组件设置唯一ID
     * 注意事项：
     *  1、当对该组件进行初始化赋值时，请一定先拿到数据值，再调用该组件，否则可能导致初始化赋值失败
     */
    import $ from 'jquery';
    export default {
        name: 'CkEditor',
        props: {
            value:String,
            height: {
                type:String,
                default:"100px"
            },
            width:{
                type:String,
                default:"100%"
            },
            id:{
                type:String,
                default:null
            }
        },
        data: function() {
            return {
                ckeditor: null
            }
        },
        created:function(){
            if(!this.id){
                alert('!ERROR:必须为CkEditor组件设置唯一ID');
            }
        },
        mounted: function() {
            const self = this;
            // 渲染编辑器
            this.ckeditor = window.CKEDITOR.replace(this.id,{
                height: this.height,
                width: this.width,
                toolbar: "Full"
            });
            // 监听内容变更事件
            this.ckeditor.on('change', function() {
                self.$emit('input', self.ckeditor.getData());
            });
            this.ckeditor.on('instanceReady',function(data) {
                   // 设置初始内容
                self.ckeditor.setData(self.value);

                let iframe = $(self.$el).find(".cke_wysiwyg_frame");
                if(!iframe ||!iframe[0]){
                    return;
                }
                $(iframe.prop('contentWindow').document).on('paste',function(event){
                    console.log('event.target:',event.target);
                    let e = event.originalEvent;
                    if (!(e.clipboardData && e.clipboardData.items)){
                        return;
                    }
                    for (let i = 0, len = e.clipboardData.items.length; i < len; i++) {
                        let item = e.clipboardData.items[i];
                        console.log('----clicp item:',item);
                        let types = item.type.split("/");
                        if(types && types[0] == 'image'){
                            if (item.kind == 'file') {
                                var pasteFile = item.getAsFile();
                                let reader = new FileReader();
                                reader.onload = function(e){
                                    //this.result 可以得到图片的base64
                                    let $image = $('<img src="'+this.result+'" style="vertical-align:middle">');
                                    console.log('----image:',$image);
                                    if(event.target.tagName=="BR"){
                                        $(event.target).before($image);
                                    }
                                    else{
                                        $(event.target).append($image);
                                    }

                                }
                                reader.readAsDataURL(pasteFile);
                            }
                        }
                    }
                })
            });
        },
        watch: {
            // 监听prop的变化，更新ckeditor中的值
            value: function() {
                if (this.value !== this.ckeditor.getData()) {
                    this.ckeditor.setData(this.value);
                }
            }
        },
        // 销毁组件前，销毁编辑器
        beforeDestroy: function() {
            this.ckeditor.destroy();
        }
    }
</script>
